export enum LogoVariant {
  Monevis = 'MONEVIS',
  Mnvs = 'MNVS',
  Symbol = 'LOGO',
}

export interface LogoProps {
  variant?: 'MONEVIS' | 'MNVS' | 'LOGO';
}

export function MonevisLogo(): JSX.Element {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fillRule="evenodd"
        strokeLinejoin="round"
        strokeMiterlimit="2"
        clipRule="evenodd"
        viewBox="0 0 340 62"
        style={{
          fillRule: 'evenodd',
          clipRule: 'evenodd',
          strokeLinejoin: 'round',
          strokeMiterlimit: 2,
          height: '100%',
          width: 'auto',
        }}
      >
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M0-21.971c1.051.015 1.458.721 2.037 1.552l8.306 14.464 8.307-14.464c.58-.831.986-1.537 2.037-1.552.297 0 .58.062.846.219.611.376 1.003 1.129.988 1.943V0h-3.793v-13.242l-6.911 11.91c-.283.454-.737 1.331-1.474 1.331-.736 0-1.19-.877-1.473-1.331l-6.911-11.91V0h-3.793v-19.809c-.015-.814.377-1.566.989-1.943.265-.156.548-.219.845-.219"
          transform="translate(-135.353 -266.914) translate(270.125 308.623)"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M0-14.887c-3.119 0-6.926.502-6.926 5.516v3.855C-6.926-.501-3.119.001 0 .001h1.331c3.134 0 6.926-.502 6.926-5.517v-3.855c0-5.014-3.792-5.516-6.926-5.516H0zM-2.054 3.542c-5.877 0-8.666-3.84-8.666-8.509V-9.92c0-4.67 2.789-8.509 8.666-8.509h5.453c5.862 0 8.666 3.824 8.666 8.509v4.953c0 4.685-2.804 8.509-8.666 8.509h-5.453z"
          transform="translate(-135.353 -266.914) translate(313.004 305.082)"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M0-20.78c5.093 4.905 9.528 10.06 14.605 14.934v-15.529h3.793v19.808c.031 1.191-.785 2.178-1.819 2.162-.486 0-.971-.219-1.378-.595C10.123-4.905 5.673-10.06.595-14.934V.595h-3.792v-19.808c-.015-1.19.799-2.178 1.833-2.162.47 0 .956.219 1.364.595"
          transform="translate(-135.353 -266.914) translate(337.89 308.028)"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M0-3.541h9.7V0H-1.786L0-3.541zM11.471 9.215H-7.052v-21.971h19.26l-1.755 3.542H-3.243V5.673h14.714v3.542z"
          transform="translate(-135.353 -266.914) translate(373.569 299.408)"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M0 19.807L-10.076-1.082h4.45l7.272 15.906L8.902-1.082h4.451L3.275 19.807c-.329.658-.97 1.082-1.629 1.082-.674 0-1.301-.424-1.646-1.082"
          transform="translate(-135.353 -266.914) translate(403.654 287.735)"
        />
        <path
          fill="currentColor"
          d="M425.553 286.653H429.361V308.624H425.553z"
          transform="translate(-135.353 -266.914) translate(0 -.001)"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M0-14.887h-10.342c-2.163 0-3.982.188-3.982 2.836 0 2.649 1.819 2.837 3.982 2.837h7.333c4.31 0 6.363 2.82 6.363 6.253v.251c0 3.431-2.054 6.252-6.363 6.252h-14.778l1.771-3.541H-4.42c2.163 0 3.98-.188 3.98-2.837 0-2.648-1.817-2.837-3.98-2.837h-7.334c-4.31 0-6.362-2.82-6.362-6.252v-.251c0-3.432 2.054-6.253 6.362-6.253H1.771L0-14.887z"
          transform="translate(-135.353 -266.914) translate(456.569 305.081)"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M0-60.615C-13.225-52.114-29.345-42.52-42.69-34.15a5.349 5.349 0 00-2.002 2.251c-3.231 6.833-6.977 14.769-10.058 21.474l-.353.779a.837.837 0 01-1.524 0c-3.203-7.009-7.044-15.124-10.412-22.253a5.342 5.342 0 00-2.002-2.251 1479.844 1479.844 0 00-15.343-9.474c-7.275-4.459-20.343-12.454-27.347-16.991-1.343-.975-3.208.396-2.651 1.986.054.215.302.537.302.537 4.789 5.79 9.146 11.919 13.737 17.863a3.53 3.53 0 01.724 1.799c.369 3.537.79 7.07 1.396 10.575a2.75 2.75 0 001.134 1.78c7.743 5.433 16.104 11.214 23.991 16.305.744.477 1.486-.572.872-1.13-1.79-1.66-3.621-3.268-5.43-4.903a1027.935 1027.935 0 00-14.883-12.879 2.753 2.753 0 01-.958-1.836c-.334-3.327-.829-6.634-1.337-9.939a3.565 3.565 0 00-.819-1.784 372.003 372.003 0 00-5.436-6.143c-.307-.34.119-.84.504-.592l12.473 8.058A2676.86 2676.86 0 00-72.877-30.77a5.338 5.338 0 011.921 2.245c4.137 9.083 8.606 18.797 12.851 27.642.848 1.849 3.629 1.858 4.479 0 4.241-8.85 8.718-18.554 12.851-27.642a5.344 5.344 0 011.921-2.245 2354.19 2354.19 0 0013.053-8.686h-.001l14.64-9.501c.384-.25.811.25.505.591a365.345 365.345 0 00-5.421 6.125 3.565 3.565 0 00-.819 1.784c-.507 3.305-1.002 6.612-1.336 9.939a2.762 2.762 0 01-.958 1.836 1022.607 1022.607 0 00-14.883 12.879c-1.81 1.635-3.641 3.243-5.431 4.903-.614.558.129 1.607.872 1.13 7.888-5.091 16.248-10.872 23.991-16.305a2.75 2.75 0 001.134-1.78c.607-3.505 1.028-7.038 1.397-10.575a3.528 3.528 0 01.723-1.799C-6.797-46.173-2.44-52.302 2.35-58.092c0 0 .247-.322.302-.537.556-1.59-1.309-2.961-2.652-1.986"
          transform="translate(-135.353 -266.914) translate(249.836 327.855)"
        />
        <path
          fill="currentColor"
          fillRule="nonzero"
          d="M0 2.25l1.118 2.209.014.014H-.21L-1.286 2.32l-.07-.126h-2.223l.545-1.076h1.79c.656 0 1.216-.21 1.216-1.133s-.56-1.132-1.216-1.132h-2.782v5.62h-1.161v-6.71h4.362c1.328 0 1.957.866 1.957 1.915v.615c0 .825-.392 1.523-1.202 1.79L0 2.25zm-.056-5.955c-.63-.14-1.286-.154-1.971-.154-.7 0-1.342.014-1.986.154-.572.126-1.118.349-1.565.699a3.43 3.43 0 00-1.3 1.915c-.182.685-.21 1.426-.21 2.209 0 .782.027 1.537.21 2.222a3.48 3.48 0 001.3 1.915c.447.336.993.574 1.565.699.644.126 1.286.14 1.986.14.685 0 1.341-.014 1.971-.14a4.12 4.12 0 001.579-.699 3.464 3.464 0 001.3-1.915c.182-.685.21-1.439.21-2.222 0-.784-.027-1.524-.21-2.209a3.416 3.416 0 00-1.3-1.915 3.946 3.946 0 00-1.579-.699M-2.027-5.02c.839 0 1.649.015 2.419.183a5.087 5.087 0 011.942.852 4.388 4.388 0 011.594 2.377c.223.839.252 1.761.252 2.726 0 .965-.029 1.887-.252 2.74a4.395 4.395 0 01-1.594 2.363c-.559.419-1.216.699-1.942.853-.77.168-1.58.196-2.419.196-.853 0-1.65-.028-2.433-.196a4.924 4.924 0 01-1.929-.853c-.755-.559-1.314-1.356-1.593-2.363-.224-.853-.266-1.775-.266-2.74 0-.965.042-1.887.266-2.726.279-1.02.838-1.817 1.593-2.377a5.118 5.118 0 011.929-.852c.783-.169 1.58-.183 2.433-.183"
          transform="translate(-135.353 -266.914) translate(470.386 274.754)"
        />
      </svg>
    </div>
  );
}

export function MnvsLogo(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinecap="square"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 350 63"
      style={{ height: '100%', width: 'auto' }}
    >
      <path
        fillRule="nonzero"
        stroke="currentColor"
        fill="currentColor"
        strokeWidth="1.3"
        d="M249.836 267.42c-13.224 8.501-29.345 18.096-42.689 26.465a5.36 5.36 0 00-2.003 2.252c-3.231 6.833-6.977 14.769-10.057 21.473l-.354.779a.837.837 0 01-1.525 0c-3.202-7.009-7.043-15.123-10.41-22.252a5.364 5.364 0 00-2.002-2.252 1462.903 1462.903 0 00-15.344-9.473c-7.275-4.459-20.342-12.455-27.346-16.992-1.344-.974-3.209.395-2.652 1.986.054.216.302.538.302.538 4.79 5.789 9.146 11.919 13.738 17.862.404.521.655 1.143.723 1.799.369 3.537.79 7.071 1.397 10.575.124.721.535 1.36 1.133 1.781 7.744 5.432 16.104 11.213 23.991 16.304.744.477 1.486-.571.873-1.129-1.791-1.66-3.621-3.268-5.431-4.903a1016.51 1016.51 0 00-14.883-12.88 2.751 2.751 0 01-.958-1.836c-.334-3.326-.829-6.634-1.336-9.938a3.561 3.561 0 00-.819-1.784 376.266 376.266 0 00-5.437-6.144c-.306-.34.119-.84.504-.591l12.473 8.057a2540.218 2540.218 0 0015.236 10.148 5.339 5.339 0 011.92 2.246c4.137 9.083 8.606 18.797 12.851 27.641.848 1.85 3.629 1.858 4.48 0 4.24-8.85 8.717-18.553 12.851-27.642a5.342 5.342 0 011.92-2.245c3.953-2.606 8.485-5.629 13.053-8.687l-.001.001 14.64-9.501c.385-.249.812.25.505.591a361.487 361.487 0 00-5.421 6.126 3.57 3.57 0 00-.819 1.784c-.507 3.304-1.002 6.612-1.336 9.938a2.755 2.755 0 01-.958 1.836 1021.774 1021.774 0 00-14.883 12.88c-1.81 1.635-3.64 3.243-5.431 4.903-.613.558.129 1.606.873 1.129 7.887-5.091 16.247-10.872 23.99-16.304a2.748 2.748 0 001.134-1.781c.607-3.504 1.028-7.038 1.397-10.575a3.53 3.53 0 01.724-1.799c4.591-5.943 8.947-12.073 13.736-17.862 0 0 .248-.322.303-.538.427-1.221-.573-2.311-1.668-2.312-.331 0-.671.1-.984.326z"
        transform="translate(-48.96 -263.265) translate(-85.644 -3.079)"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M.129-.693a.073.073 0 00-.031.062V0h.096v-.511l.231.455C.445-.017.457 0 .482 0c.024 0 .037-.017.056-.056L.77-.511V0h.096v-.631a.072.072 0 00-.032-.062A.054.054 0 00.808-.7c-.032 0-.051.021-.065.049l-.261.518-.261-.518C.206-.679.188-.7.156-.7a.054.054 0 00-.027.007z"
        transform="translate(-48.96 -263.265) matrix(.79965 0 0 .8095 16.683 252.376) matrix(72 0 0 72 198.218 77.198)"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M.156-.7c-.033 0-.059.031-.058.069V0h.096v-.552l.486.533A.067.067 0 00.724 0c.033 0 .059-.031.058-.069V-.7H.686v.552L.2-.681A.067.067 0 00.156-.7z"
        transform="translate(-48.96 -263.265) matrix(.79965 0 0 .8095 16.683 252.376) matrix(72 0 0 72 264.314 77.198)"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M.396 0a.06.06 0 00.052-.034L.765-.7H.656l-.26.564L.136-.7H.027l.317.666C.355-.013.374 0 .396 0z"
        transform="translate(-48.96 -263.265) matrix(.79965 0 0 .8095 16.683 252.376) matrix(72 0 0 72 325.442 77.198)"
      />
      <path
        fill="currentColor"
        fillRule="nonzero"
        d="M.644-.197c0 .116-.089.108-.16.108H.119L.074 0h.469C.65 0 .74-.061.74-.193c0-.138-.084-.201-.197-.201H.274C.189-.396.162-.448.162-.508c0-.079.052-.103.141-.103h.342L.69-.7H.261c-.107 0-.197.061-.197.193 0 .138.083.201.197.201h.261c.049.001.122.014.122.109z"
        transform="translate(-48.96 -263.265) matrix(.79965 0 0 .8095 16.683 252.376) matrix(72 0 0 72 379.73 77.198)"
      />
    </svg>
  );
}

export function SymbolLogo(): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlSpace="preserve"
      style={{
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        strokeLinejoin: 'round',
        strokeMiterlimit: 2,
        height: '100%',
        width: 'auto',
      }}
      viewBox="0 0 735 379"
    >
      <path
        d="M0-88.98c-10.359 6.711-29.685 18.535-40.445 25.129A2214.668 2214.668 0 0 0-63.137-49.84a7.932 7.932 0 0 0-2.962 3.331c-4.778 10.105-10.318 21.843-14.874 31.759l-.523 1.152c-.44.968-1.815.968-2.255 0l-.523-1.152c-4.556-9.916-10.095-21.654-14.874-31.759a7.924 7.924 0 0 0-2.962-3.33 2197.29 2197.29 0 0 0-22.692-14.012c-10.76-6.594-30.086-18.418-40.445-25.129-1.987-1.442-4.745.585-3.922 2.937.081.319.447.795.447.795l.018.021c1.672 2.063 3.356 4.123 4.986 6.22 5.209 6.64 10.139 13.509 15.314 20.177a5.222 5.222 0 0 1 1.07 2.661c.545 5.231 1.168 10.457 2.065 15.641a4.068 4.068 0 0 0 1.677 2.632c11.452 8.035 23.817 16.585 35.482 24.114 1.1.706 2.197-.845 1.29-1.671-2.648-2.455-5.356-4.832-8.032-7.25a1504.699 1504.699 0 0 0-22.011-19.048 4.078 4.078 0 0 1-1.417-2.716c-.494-4.92-1.226-9.812-1.977-14.7a5.263 5.263 0 0 0-1.211-2.638c-2.637-3.064-5.335-6.079-8.041-9.085-.453-.504.177-1.243.746-.876l18.447 11.917c7.828 5.244 15.755 10.54 22.533 15.009a7.903 7.903 0 0 1 2.841 3.32c4.392 9.627 9.473 20.722 13.811 29.955l5.195 10.927c.136.285.313.535.507.767.01.014.024.025.035.038.129.15.262.294.411.419.112.098.24.179.366.262.07.045.134.096.206.137.033.018.06.044.093.061.105.054.215.083.322.126.091.037.179.078.273.107.136.043.272.07.41.096.105.021.209.043.316.054.126.013.249.013.373.012.125.001.248.001.374-.012.107-.011.211-.033.316-.054.138-.026.274-.053.41-.096.094-.029.182-.07.273-.107.107-.043.217-.072.322-.126.033-.017.06-.043.093-.061.072-.041.137-.092.206-.137.126-.083.254-.164.366-.262.149-.125.282-.269.411-.419.011-.013.025-.024.035-.038.194-.232.371-.482.507-.767l5.195-10.927c4.338-9.233 9.419-20.328 13.811-29.955a7.903 7.903 0 0 1 2.841-3.32A3483.768 3483.768 0 0 0-38.16-57.687l-.001.001 21.652-14.053c.569-.369 1.201.371.747.875-2.698 2.998-5.387 6.004-8.017 9.059a5.263 5.263 0 0 0-1.211 2.638c-.751 4.888-1.483 9.78-1.976 14.7a4.084 4.084 0 0 1-1.418 2.716 1509.964 1509.964 0 0 0-22.011 19.048c-2.676 2.418-5.384 4.795-8.032 7.25-.907.826.19 2.377 1.29 1.671 11.665-7.529 24.03-16.079 35.482-24.114a4.068 4.068 0 0 0 1.677-2.632c.897-5.184 1.52-10.41 2.065-15.641.102-.97.473-1.89 1.071-2.661 5.174-6.668 10.104-13.537 15.313-20.177 1.63-2.097 3.314-4.157 4.986-6.22l.018-.021s.366-.476.447-.795C4.745-88.395 1.987-90.422 0-88.98"
        style={{
          fill: 'currentColor',
          fillRule: 'nonzero',
        }}
        transform="translate(705.496 372.759) scale(4.16667)"
      />
    </svg>
  );
}

export function Logo({ variant = LogoVariant.Mnvs }: LogoProps): JSX.Element {
  switch (variant) {
    case 'MONEVIS':
      return <MonevisLogo />;
    case 'MNVS':
      return <MnvsLogo />;
    case 'LOGO':
      return <SymbolLogo />;
  }
}
